var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGroupEnabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/group/hover",
    transform: "translate(-7.000000, -7.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5C7284",
    x: 2.5,
    y: 2.5,
    width: 5,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#5C7284",
    x: 2.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#5C7284",
    x: 10.5,
    y: 2.5,
    width: 5,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#5C7284",
    x: 10.5,
    y: 10.5,
    width: 5,
    height: 5,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupEnabled);
export default __webpack_public_path__ + "static/media/icon_group_enabled.0c99accb.svg";
export { ForwardRef as ReactComponent };